<template>
  <div class="room-entry">
    <Tabs type="card" name="tab-info">
      <TabPane tab="tab-info" label="主讲">
        <div class="wrap s-top">
          <div class="inputbox">
            <span class="label">网页开播链接：</span>
            <Input :value="pullUrlArr.teach.web" style="width: 200px;" readonly disabled>
            <span style="user-select: none;cursor: pointer;" slot="append" @click="copyLiveUrl(pullUrlArr.teach.web)">复制</span>
            </Input>
            <span class="open-btn" @click="openHandle(pullUrlArr.teach.web)">打开</span>
          </div>

          <div class="inputbox">
            <span class="label">启动客户端链接：</span>
            <Input :value="pullUrlArr.teach.backend" style="width: 200px;" readonly disabled>
            <span style="user-select: none;cursor: pointer;" slot="append" @click="copyLiveUrl(pullUrlArr.teach.backend)">复制</span>
            </Input><span class="open-btn" @click="openHandle(pullUrlArr.teach.backend)">打开</span>
          </div>
        </div>
      </TabPane>
      <!-- <TabPane tab="tab-info" label="助教">
        <div class="wrap s-top">
          <div class="inputbox">
            <span class="label">助教后台链接：</span>
            <Input :value="pullUrlArr.guest" style="width: 200px;" readonly disabled>
            <span style="user-select: none;cursor: pointer;" slot="append"
              @click="copyLiveUrl(pullUrlArr.guest)">复制</span>
            </Input>
            <span class="open-btn" @click="openHandle(pullUrlArr.guest)">打开</span>
          </div>
        </div>
      </TabPane> -->
      <TabPane tab="tab-info" label="观众">
        <div class="wrap s-top">
          <!-- <div class="inputbox">
            <span class="label">观众：</span>
            <Input :value="pullUrlArr.user" style="width: 200px;" readonly disabled>
            <span style="user-select: none;cursor: pointer;" slot="append"
              @click="copyLiveUrl(pullUrlArr.user)">复制</span>
            </Input>
            <span class="open-btn" @click="openHandle(pullUrlArr.user)">打开</span>
          </div> -->
          <div class="inputbox s-top" v-if="sunCode">
            <span class="label">小程序观看：</span>
            <img :src="sunCode" />
            <span class="open-btn" @click="downloadCodeImg(sunCode)" style="width:100%;padding-left:142px;padding-top:10px;">下载</span>
          </div>
        </div>
      </TabPane>
      <TabPane tab="tab-info" label="第三方推流">
        <div class="wrap s-top">
          <div class="inputbox">
            <span class="label">推流链接：</span>
            <Input :value="pushUrl" style="width: 200px;" readonly disabled>
            <span style="user-select: none;cursor: pointer;" slot="append" @click="copyLiveUrl(pushUrl)">复制</span>
            </Input>
          </div>
          <p style="font-size: 12px;color: #a29f9f;padding-left:50px">推流地址30分钟内推上有效，超过30分钟未推流，请刷新后台获取最新推流地址</p>
        </div>
      </TabPane>
      <TabPane tab="tab-info" label="企业公众号">
        <div class="wrap s-top">
          <Poptip :transfer="true" placement="right-start" word-wrap width="350">
            <div class="tip">
              <Icon type="md-eye" /> 关注企业公众号效果预览
            </div>
            <div class="api" slot="content">
              <img src="@/assets/img/live/preview-bg.png" width="300">
            </div>
          </Poptip>
          <div class="inputbox">
            <span class="label">关注企业公众号：</span>
            <iSwitch v-model="liveWeChatEnable" />
          </div>
          <div class="inputbox">
            <span class="label">入口文案：</span>
            <Input v-model="liveWeChatEntranceText" maxlength="8" show-word-limit placeholder="关注公众号入口文案" style="width: 200px" />
          </div>
          <div class="inputbox">
            <span class="label">公众号二维码：</span>
            <div class="my-upload">
              <div class="my-upload-list" v-for="(item, index) in uploadList" :key="'upload1-' + index" style="margin:0;">
                <template v-if="item.status === 'finished'">
                  <img :src="item.url" style="width: 100px;height: 100px;" />
                  <div class="my-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                    <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                  </div>
                </template>
                <template v-else>
                  <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                    <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
                  </Spin>
                </template>
              </div>
              <Upload ref="upload999" :show-upload-list="false" :default-file-list="defaultList" :on-success="handleSuccess" :format="['jpg', 'jpeg', 'png']" :max-size="256" :headers="formHeaders"
                :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" multiple type="drag" :action="uploadUrl" style="display: inline-block;"
                v-show="uploadList && uploadList.length < 1">
                <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                  <div style="font-size:25px">
                    +
                    <p style="font-size:14px">上传图片</p>
                  </div>
                </div>
              </Upload>
              <iModal title="图片查看" cancel-text v-model="visible">
                <div style="text-align: center;">
                  <img :src="imgName" v-if="visible" style="max-width: 100%" />
                </div>
              </iModal>
            </div>
            <p style="font-size: 12px;color: #a29f9f;padding-left:120px;padding-top:10px;width:100%">请上传文件大小不大于200k的二维码，支持jpg/png格式</p>

          </div>
          <div class="inputbox">
            <span class="label">弹窗提示文案：</span>
            <Input v-model="liveWeChatTips" maxlength="30" show-word-limit placeholder="关注公众号弹窗提示文案" style="width: 200px" /></Input>
          </div>
          <div class="inputbox">
            <span class="label">主动弹窗：</span>
            <iSwitch v-model="liveWeChatAutoShowEnabled" />
          </div>
          <p style="font-size: 12px;color: #a29f9f;padding-left:120px;">开启后打开观看页会主动弹窗显示二维码</p>
          <Button :loading="loading" type="primary" @click="changeWechat()" style="margin-left:120px;margin-top:20px;">确定保存</Button>

        </div>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "room-push",
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      pushUrl: '',
      url: 'https://img.zhanshangxiu.com/showonline/file/qr/202210/cd10cb1a16144cdbae9c46262518a1cf.jpg',
      activity: null,
      sunCode: '',

      liveWeChatEnable: false, // 关注公众号功能是否启用
      liveWeChatQrCode: '', // 关注公众号二维码
      liveWeChatAutoShowEnabled: false, // 关注公众号 是否主动弹窗
      liveWeChatEntranceText: '', // 关注公众号 入口文案
      liveWeChatTips: '', // 关注公众号 弹窗提示文案


      TabsCur: "主讲",
      imgName: "",
      visible: false,
      defaultList: [],
      uploadList: [],
    };
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
    activityId () {
      return this.$route.query.activityId;
    },
    channelId () {
      return this.$route.query.channelId;
    },
    pullUrlArr () {
      return {
        teach: {
          web: `https://live.polyv.net/web-start/?channelId=${this.channelId}`,
          backend: `https://console.polyv.net/live/start-client.html?channelId=${this.channelId}`,
        },
        guest: `https://console.polyv.net/live/login.html?channelId=${this.channelId}`,
        user: `https://0c97b022f4.live.polyv.cn/watch/${this.channelId}`,
      }
    }
  },
  methods: {
    ...mapActions({
      updateWeChat: "liveModule/updateWeChat",
      pushUrlhandle: "liveModule/pushUrlhandle",
      getActById: "hostActModule/getActById",
      getWeAppCode: "exhibitionModule/getWeAppCode",
      updateWeChat: "liveModule/updateWeChat",
    }),
    ...mapMutations({
      setActivity: "liveModule/setActivity",
    }),
    getQrCode () {
      this.$refs.qrCodeUrl.innerHTML = "";
      if (this.pullUrlArr && this.pullUrlArr.user) {
        let qrcode = new QRCode("qrcodeShare", {
          width: 130,
          height: 130,
          text: this.pullUrlArr.user, // 二维码内容
          correctLevel: QRCode.CorrectLevel.L, 
        });
      }
    },
    copyLiveUrl (url) {
      const input = document.createElement("input");
      document.body.appendChild(input);
      input.setAttribute("value", url);
      input.select();
      if (document.execCommand("copy")) {
        document.execCommand("copy");
        this.$Message.success("复制成功");
      }
      document.body.removeChild(input);
    },
    downloadCodeImg (url) {
    //   var image = new Image();
    //   image.setAttribute("crossOrigin", "anonymous");
    //   var _this = this;
    //   image.onload = function () {
    //     var canvas = document.createElement("canvas");
    //     canvas.width = image.width;
    //     canvas.height = image.height;
    //     var context = canvas.getContext("2d");
    //     context.drawImage(image, 0, 0, image.width, image.height);
    //     var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据
    //     var a = document.createElement("a"); // 生成一个a元素
    //     var event = new MouseEvent("click"); // 创建一个单击事件
    //     a.download = _this.projectName || "photo"; // 设置图片名称
    //     a.href = url; // 将生成的URL设置为a.href属性
    //     a.dispatchEvent(event); // 触发a的单击事件
    //   };
    //   image.src = url;
    window.open(url,'_blank')
    // this.downloadIamge(url, 'photo');
    
    },
    downloadIamge(imgsrc, name) {
                //下载图片地址和图片名
                var image = new Image();
                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous");
                image.onload = function() {
                    var canvas = document.createElement("canvas");
                    canvas.width = image.width;
                    canvas.height = image.height;
                    var context = canvas.getContext("2d");
                    context.drawImage(image, 0, 0, image.width, image.height);
                    var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据'
                    var a = document.createElement("a"); // 生成一个a元素
                    var event = new MouseEvent("click", {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    }); // 创建一个单击事件
                    a.download = name || "photo"; // 设置图片名称
                    a.href = url; // 将生成的URL设置为a.href属性
                    a.dispatchEvent(event); // 触发a的单击事件
                };
                image.src = imgsrc;
            },

    openHandle (url) {
      window.open(url, '_blank');
    },
    async init () {
      let pushurl = await this.pushUrlhandle(this.channelId);
      console.log('pushurl', pushurl);
      this.pushUrl = pushurl || '';
      if (!this.activityId) return;
      let actDetail = await this.getActById(this.activityId);
      if (actDetail) {
        this.activity = actDetail || null;
        this.sunCode = this.activity.sunCode || '';
        this.setActivity(this.activity);

        this.liveWeChatEnable = actDetail.liveWeChatEnable || false; // 关注公众号功能是否启用 
        this.liveWeChatAutoShowEnabled = actDetail.liveWeChatAutoShowEnabled || false; // 关注公众号 是否主动弹窗
        this.liveWeChatEntranceText = actDetail.liveWeChatEntranceText || ''; // 关注公众号 入口文案
        this.liveWeChatTips = actDetail.liveWeChatTips || ''; // 关注公众号 弹窗提示文案
        this.liveWeChatQrCode = actDetail.liveWeChatQrCode || ''; // 关注公众号 弹窗提示文案
        if (actDetail.liveWeChatQrCode) {
          this.uploadList = [
            {
              url: actDetail.liveWeChatQrCode,
              status: "finished",
              percentage: 100,
            },
          ];
        }
      }
      if (this.sunCode) return;
      //获取小程序码
      let opt = {
        targetType: 5,
        targetId: this.activity.id,
        scene: this.activity.id + " " + (this.activity.exhibitionId || ''),
      };
      let data = await this.getWeAppCode(opt);
      if (data) {
        this.sunCode = data.path;
      }
    },


    // 查看上传图片
    handleView (name) {
      this.imgName = name;
      this.visible = true;
    },
    // 上传成功
    async handleSuccess (res, file, fileList) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload999.fileList;
        this.liveWeChatQrCode = file.url;
      }
    },
    // 文件格式错误
    handleFormatError (file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 上传数量
    handleBeforeUpload () {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    // 移除上传图片
    handleRemove (file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 文件过大
    handleMaxSize (file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于200k的图片`);
    },
    async changeWechat () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      if (this.liveWeChatEnable && !this.liveWeChatQrCode) {
        this.$Message.error(`开启关注企业公众号，二维码为必传项！`);
        return;
      }
      let opt = {
        activityId: this.activityId,
        liveWeChatEnable: this.liveWeChatEnable, // 关注公众号功能是否启用
        liveWeChatQrCode: this.liveWeChatQrCode, // 关注公众号二维码
        liveWeChatAutoShowEnabled: this.liveWeChatAutoShowEnabled, // 关注公众号 是否主动弹窗
        liveWeChatEntranceText: this.liveWeChatEntranceText, // 关注公众号 入口文案
        liveWeChatTips: this.liveWeChatTips, // 关注公众号 弹窗提示文案
      };
      let bool = await this.updateWeChat(opt);
      this.loading = false;
      if (bool && bool.data && bool.data.live && bool.data.live.updateWeChat) {
        this.$Message.success("操作成功！");
        this.init();
      } else {
        let err = "操作失败，请重新尝试";
        if (bool.errors && bool.errors[0]) {
          err = bool.errors[0].message;
        }
        this.$Message.error(err);
      }
    },
  },
  mounted () {
    this.init();
  }
}

</script>

<style lang="scss" scoped>
.room {
  &-entry {
    padding-bottom: 12px;
    text-align: center;
    background: #fff;

    /deep/ .ivu-tabs {
      .ivu-tabs-bar {
        margin-bottom: 40px;
        border-bottom: none;
        padding: 0;

        .ivu-tabs-nav-container {
          height: 42px;

          .ivu-tabs-nav-wrap {
            .ivu-tabs-nav-scroll {
              .ivu-tabs-nav {
                &::before,
                &::after {
                  display: none;
                }

                .ivu-tabs-ink-bar {
                  display: none;
                }

                width: 100%;
                display: flex;
                justify-content: space-between;

                .ivu-tabs-tab {
                  padding: 0;
                  width: 49.5%;
                  border-radius: 0;
                  height: 42px;
                  justify-content: center;
                  display: flex;
                  align-items: center;
                  border: none;
                  margin: 0;
                  box-shadow: 0px 0px 10px 0px rgba(146, 160, 185, 0.3);
                }
              }
            }
          }
        }
      }
    }

    .txt2 {
      font-size: 14px;
      color: #333;
      padding: 0 10px;
    }
  }
}

.wrap {
  min-height: 200px;
  text-align: left;
  padding: 0 2%;
  position: relative;
  &.s-top {
    padding-top: 2%;
  }

  margin-top: -20px;

  .inputbox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;

    &.s-top {
      align-items: inherit !important;

      img {
        width: 100px;
      }
    }

    .open-btn {
      color: #2d8cf0;
      display: inline-block;
      margin-left: 10px;
      cursor: pointer;
    }
  }

  .label {
    width: 120px;
    text-align: right;
  }
  .tip {
    color: #2d8cf0;
    cursor: pointer;
    padding-left: 120px;
    margin: 10px 0;
  }
}
</style>
